export default {"src":"/_next/static/media/heart-filled-white-46x46.1d758450.svg","height":19,"width":22};